import type { ReactNode } from "react";

import type { createToaster } from "@ark-ui/react/toast";
import type { Options } from "@zag-js/toast";

type CreateToasterReturn = ReturnType<typeof createToaster<ReactNode>>;

export type SnackApi = {
  create<T extends ReactNode>(
    content: ReactNode,
    options?: Omit<Options<T>, "type" | "title">,
  ): string;
} & Omit<CreateToasterReturn, "success" | "error" | "create">;

export function createSnackApi(snack: CreateToasterReturn): SnackApi {
  return {
    ...snack,
    create(content, options) {
      return snack.create({
        ...options,
        title: content,
      });
    },
  };
}
